import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AIONZ_TOOLTIP_DATA } from '@aionzdev/design-system';
import { DurationFormatService } from '../../pages/purchasing-manager/services/duration-format.service';
import { TimePerStageTooltipData } from '../../../interfaces/time-per-stage-tooltip-data';

@Component({
  selector: 'aionz-time-per-stage-tooltip',
  imports: [],
  templateUrl: './time-per-stage-tooltip.component.html',
  styleUrl: './time-per-stage-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimePerStageTooltipComponent {
  private readonly durationFormat = inject(DurationFormatService);
  protected readonly data = inject(AIONZ_TOOLTIP_DATA) as TimePerStageTooltipData;

  public get title(): string {
    return this.data.title ?? 'Tempo por etapa';
  }

  public get totalLabel(): string {
    return this.data.totalLabel ?? 'Tempo total';
  }

  public get displayItems() {
    return this.data.items.map(item => ({
      ...item,
      color: item.color ?? '#06A84B',
      time: this.durationFormat.formatFromHours(item.time)
    }));
  }

  public get displayTotal() {
    const total = this.data.totalTime;
    return total != null ? this.durationFormat.formatFromHours(total) : '--';
  }
}
